import { apiUrl } from '@/config/api';

export const toAbsoluteImageUrl = (value) => {
  if (!value || typeof value !== 'string') {
    return '';
  }

  const trimmed = value.trim();
  const isAbsolute = /^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:');

  if (isAbsolute) {
    return trimmed;
  }

  try {
    const url = new URL(trimmed);
    return url.href;
  } catch (_error) {
    return apiUrl(trimmed);
  }
};

export default toAbsoluteImageUrl;
